/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UpgradeInputs */

const en_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const de_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden`)
};

const fr_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau`)
};

const es_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan`)
};

const it_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const nl_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden`)
};

const pl_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz`)
};

const fi_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä`)
};

const da_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader`)
};

const sv_common_upgrade = /** @type {(inputs: Common_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {Common_UpgradeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_upgrade = /** @type {((inputs?: Common_UpgradeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UpgradeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_upgrade(inputs)
	if (locale === "fr") return fr_common_upgrade(inputs)
	if (locale === "es") return es_common_upgrade(inputs)
	if (locale === "it") return it_common_upgrade(inputs)
	if (locale === "nl") return nl_common_upgrade(inputs)
	if (locale === "pl") return pl_common_upgrade(inputs)
	if (locale === "fi") return fi_common_upgrade(inputs)
	if (locale === "da") return da_common_upgrade(inputs)
	if (locale === "sv") return sv_common_upgrade(inputs)
	return en_common_upgrade(inputs)
});